module.exports = __webpack_public_path__ + "img/leftlogin.d507e8a0.jpg";